export default __webpack_public_path__ + "assets/ordercard-initial-tutorial-step1-image.png";